import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import ProfileNav from "../ProfileNav";
import Terms from "../teamScans/Terms";
import Header from "./Header";
import Landing from "./Landing";
import ThreadLoader from "./ThreadLoader";

const Main = styled.div`
    flex-grow: 1;
    padding: 0 10px;
    width: 100%;
    max-width: 1440px;
`;

function AiChatbotRoutes(): JSX.Element {
    return (
        <>
            <Header />
            <Main>
                <Routes>
                    <Route path="/profile/*" element={<ProfileNav />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/:id" element={<ThreadLoader />} />
                    <Route path="/" element={<Landing />} />
                </Routes>
            </Main>
        </>
    );
}

export default AiChatbotRoutes;
